//@ts-check

/**
 * 必須チェック
 * @param {string} val
 * @return {boolean}
 */
const isRequired = val => {
  if (!val || val === "") return false;
  return true;
};

/**
 * 正規表現チェック
 * @param {RegExp} regex
 * @param {string} val
 * @return {boolean}
 */
const isRegex = (regex, val) => regex.test(val);

/**
 * 全角チェック
 * @param {string} val
 * @return {boolean}
 */
// eslint-disable-next-line no-control-regex
const isZenkaku = val => isRegex(/^[^\x01-\x7E\xA1-\xDF]+$/, val);

/**
 * 平仮名チェック
 * @param {string} val
 * @return {boolean}
 */
const isHiragana = val => isRegex(/^[\u3041-\u3096]+$/, val);

/**
 * 片仮名チェック
 * @param {string} val
 * @return {boolean}
 */
const isKatakana = val => isRegex(/^[\u30a1-\u30f6]+$/, val);

/**
 * 英数字チェック
 * @param {string} val
 * @return {boolean}
 */
const isAlphanumeric = val => isRegex(/^[0-9a-zA-Z]+$/, val);

/**
 * 数字チェック
 * @param {string} val
 * @return {boolean}
 */
const isNumeric = val => isRegex(/^[0-9]+$/, val);

/**
 * 英字チェック
 * @param {string} val
 * @return {boolean}
 */
const isAlphabetic = val => isRegex(/^[a-zA-Z]+$/, val);

/**
 * 大文字英字チェック
 * @param {string} val
 * @return {boolean}
 */
const isUpperAlphabetic = val => isRegex(/^[A-Z]+$/, val);

/**
 * 小文字英字チェック
 * @param {string} val
 * @return {boolean}
 */
const isLowerAlphabetic = val => isRegex(/^[a-z]+$/, val);

/**
 * Eメールチェック
 * @param {string} val
 * @return {boolean}
 */
const isEMail = val =>
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    val
  );

/**
 * Jsonチェック
 * @param {string} val
 * @return {boolean}
 */
const isJson = val => {
  try {
    JSON.parse(val);
  } catch {
    return false;
  }
  return true;
};

export {
  isRequired,
  isZenkaku,
  isHiragana,
  isKatakana,
  isAlphanumeric,
  isNumeric,
  isAlphabetic,
  isUpperAlphabetic,
  isLowerAlphabetic,
  isEMail,
  isJson
};
